import script from "./GamePage.vue?vue&type=script&setup=true&lang=js"
export * from "./GamePage.vue?vue&type=script&setup=true&lang=js"

import "./GamePage.vue?vue&type=style&index=0&id=1c3f8262&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c3f8262"]])

export default __exports__